import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';
import HomeKnowledgeBookServices from '../services/HomeKnowledgeBookServices';
import type { IHomeKnowledgeBook } from '../constants/interfaces';

const HomeKnowledgeBookActions = {
    async getRecentKnowledgeBooks(): Promise<IHomeKnowledgeBook[]> {
        const data = await HomeKnowledgeBookServices.getRecentOpenedKnowledgeBooks();
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: HomeConstants.HOME_KB_GET_RECENT,
            data,
        });
        return data;
    },

    async getFavoriteKnowledgeBooks(): Promise<IHomeKnowledgeBook[]> {
        const data = await HomeKnowledgeBookServices.getFavoriteKnowledgeBooks();
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: HomeConstants.HOME_KB_GET_FAVORITES,
            data,
        });
        return data;
    },
};

export default HomeKnowledgeBookActions;
